export default {
  "form": {
    "select": {
      "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bitte wählen"])}
    },
    "input": {
      "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stück"])}
    }
  },
  "buttons": {
    "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montageanleitung downloaden"])},
    "watchlistAdd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zur Merkliste hinzufügen"])},
    "watchlistAdded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zur Merkliste hinzugefügt"])},
    "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jetzt anfragen"])}
  },
  "labels": {
    "model": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modell"])},
    "productGroup": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Produktgruppe"])},
    "articleNumber": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Artikelnummer"])},
    "technicalNote": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technische Bemerkung"])}
  },
  "error": {
    "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie müssen eine Auswahl treffen!"])}
  }
}